import React from 'react';
import { useStyles } from './styles';
import { Box, Button, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

export const LmaNotAllowed = (props) => {

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle }}} onClose={props.handleCancelIcon} open={props.open}>
      <Box className={classes.root}>
        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>Loss Mitigation Application Currently Unavailable</Typography>
        </Box>
        
        <Box className={classes.cardBodyContainer}>
          <Box className={classes.statusContainer}>
           <Box className={classes.cardContainer}>
             <Typography className={classes.paragraph}>Unfortunately, your current loan status does not meet the eligibility requirements for a hardship application under loss mitigation at this time.</Typography> 
             <Typography className={classes.paragraph}>For further assistance or to explore other options, please contact our <Link className={classes.linkStyle} onClick={props.handleClose} to='/HelpLanding?contactus'>Customer Care</Link>.</Typography> 
            </Box> 
          </Box>
        </Box>

        <Box className={classes.cardFooter}>
          <Button
            variant='contained'
            color='primary'
            className={classes.btn}
            onClick={props.handleCancelIcon}
            >Got it</Button>
        </Box>
      </Box> 
    </Dialog>
  )
}
